/*
 * jQuery Minimun Password Requirements 1.1
 * http://elationbase.com
 * Copyright 2014, elationbase
 * Check Minimun Password Requirements
 * Free to use under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
*/

(function($){
    $.fn.extend({
        passwordRequirements: function(options) {

            // Options for the plugin
            var defaults = {
                numCharacters: 8,
                useLowercase: true,
                useUppercase: true,
                useNumbers: true,
                useSpecial: true,
                mustMatch: true,
                reuseCheckText: '',
                passwordReused: false,
                infoMessage: '',
                style: "light",
                fadeTime: 300,
                inputElement: $(".pr-password"),
                containerElement: $("#pr_box_container")
            };

            options = $.extend(defaults, options);

            return this.each(function() {
                var translationMap = window.I18n.translations[I18n.locale];
                var o = options;
                o.infoMessage = translationMap.views.devise.confirmations.show.password_requirements.header_1;

                // Add Variables for the li elements
                var numCharactersUI = '<li class="pr-numCharacters"><span class="pr-icon"></span>' + o.numCharacters + ' ' + translationMap.views.devise.confirmations.show.password_requirements.text_1 + '</li>',
                    useLowercaseUI = '',
                    useUppercaseUI = '',
                    useNumbersUI   = '',
                    useSpecialUI   = '',
                    mustMatchUI    = '',
                    noReuseUI      = '';

                // Check if the options are checked
                if (o.useLowercase === true) {
                    useLowercaseUI = '<li class="pr-useLowercase"><span class="pr-icon"></span>'+ translationMap.views.devise.confirmations.show.password_requirements.text_2 + '</li>';
                }
                if (o.useUppercase === true) {
                    useUppercaseUI = '<li class="pr-useUppercase"><span class="pr-icon"></span>' + translationMap.views.devise.confirmations.show.password_requirements.text_3 + '</li>';
                }
                if (o.useNumbers === true) {
                    useNumbersUI = '<li class="pr-useNumbers"><span class="pr-icon"></span>' + translationMap.views.devise.confirmations.show.password_requirements.text_4 + '</li>';
                }
                if (o.useSpecial === true) {
                    useSpecialUI = '<li class="pr-useSpecial"><span class="pr-icon"></span>' + translationMap.views.devise.confirmations.show.password_requirements.text_5 + '</li>';
                }
                if (o.mustMatch === true) {
                    mustMatchUI = '<li class="pr-mustMatch"><span class="pr-icon"></span>' + translationMap.views.devise.confirmations.show.password_requirements.text_6 + '</li>';
                }
                // Reuse is checked on the server after submit, so this item is only marked when that check failed
                if (o.reuseCheckText) {
                    noReuseUI = '<li class="pr-noReuse' + (o.passwordReused ? ' pr-failed' : '') + '"><span class="pr-icon"></span>' + o.reuseCheckText + '</li>';
                }

                // Append password hint div
                var messageDiv = '<div id="pr-box"><div id="pr-box-inner"><p class="password-desc">' + o.infoMessage + '</p><ul>' + numCharactersUI + useLowercaseUI + useUppercaseUI + useNumbersUI + useSpecialUI + mustMatchUI + noReuseUI + '</ul></div></div>';

                // Set completion variables
                var numCharactersDone = true,
                    useLowercaseDone  = true,
                    useUppercaseDone  = true,
                    useNumbersDone    = true,
                    useSpecialDone    = true,
                    mustMatchDone     = true;

                // Show Message reusable function
                o.inputElement.each(function() {
                    // Find the position of element
                    var posH   = $(this).offset().top,
                        itemH  = $(this).innerHeight(),
                        totalH = posH + itemH,
                        itemL  = $(this).offset().left;
                    // Append info box to the body
                    o.containerElement.append(messageDiv);
                    $("#pr-box").addClass(o.style).fadeIn(o.fadeTime);
                });

                // Show password hint
                // $(this).on("focus",function (){
                //     showMessage();
                // });

                // Delete Message reusable function
                // var deleteMessage = function () {
                //     var targetMessage = $("#pr-box");
                // };

                // Show / Delete Message when completed requirements function
                // var checkCompleted = function () {
                //     if (numCharactersDone === true && useLowercaseDone === true && useUppercaseDone === true && useNumbersDone === true && useSpecialDone === true && mustMatchDone === true) {
                //         deleteMessage();
                //     } else {
                //         showMessage();
                //     }
                // };

                // Show password hint
                // $(this).on("blur", function (){
                //     deleteMessage();
                // });

                // Show or Hide password hint based on user's event
                // Set variables
                var lowerCase               = new RegExp('[a-z]'),
                    upperCase               = new RegExp('[A-Z]'),
                    numbers                 = new RegExp('[0-9]'),
                    specialCharacter        = new RegExp('[_+<>#?!@$%^&*~-]');

                // Show or Hide password hint based on keyup
                $(this).on("keyup focus", function () {
                    var thisVal = $(this).val();
                    var otherPasswordFieldId = this.id === "user_password" || this.id === "user_password_confirmation" ? "user_password_confirmation" : "user_new_password_confirmation";
                    var thisOtherVal = $("#" + otherPasswordFieldId).val();

                    // Check # of characters
                    if (thisVal.length >= o.numCharacters) {
                        $(".pr-numCharacters").addClass("pr-met");
                        numCharactersDone = true;
                    } else {
                        $(".pr-numCharacters").removeClass("pr-met");
                        numCharactersDone = false;
                    }

                    // Lowercase meet requirements
                    if (o.useLowercase === true) {
                        if (thisVal.match(lowerCase)) {
                            $(".pr-useLowercase").addClass("pr-met");
                            useLowercaseDone = true;
                        } else {
                            $(".pr-useLowercase").removeClass("pr-met");
                            useLowercaseDone = false;
                        }
                    }

                    // Uppercase meet requirements
                    if (o.useUppercase === true) {
                        if (thisVal.match(upperCase)) {
                            $(".pr-useUppercase").addClass("pr-met");
                            useUppercaseDone = true;
                        } else {
                            $(".pr-useUppercase").removeClass("pr-met");
                            useUppercaseDone = false;
                        }
                    }

                    // Numbers meet requirements
                    if (o.useNumbers === true) {
                        if (thisVal.match(numbers)) {
                            $(".pr-useNumbers").addClass("pr-met");
                            useNumbersDone = true;
                        } else {
                            $(".pr-useNumbers").removeClass("pr-met");
                            useNumbersDone = false;
                        }
                    }

                    // Special characters meet requirements
                    if (o.useSpecial === true) {
                        if (thisVal.match(specialCharacter)) {
                            $(".pr-useSpecial").addClass("pr-met");
                            useSpecialDone = true;
                        } else {
                            $(".pr-useSpecial").removeClass("pr-met");
                            useSpecialDone = false;
                        }
                    }

                    // mustMatch meet requirements
                    if (o.mustMatch === true) {
                        if (thisVal !== '' && thisVal !== undefined && thisVal !== null && thisVal === thisOtherVal) {
                            $(".pr-mustMatch").addClass("pr-met");
                            mustMatchDone = true;
                        } else {
                            $(".pr-mustMatch").removeClass("pr-met");
                            mustMatchDone = false;
                        }
                    }
                    // checkCompleted();
                });

                $("#user_password_confirmation, #user_new_password_confirmation").on("keyup focus", function () {
                    var thisVal = $(this).val();
                    var otherPasswordFieldId = this.id === "user_password_confirmation" ? "user_password" : "user_new_password";
                    var thisOtherVal = $("#" + otherPasswordFieldId).val();

                    // mustMatch meet requirements
                    if (o.mustMatch === true) {
                        if (thisVal !== '' && thisVal !== undefined && thisVal !== null && thisVal === thisOtherVal) {
                            $(".pr-mustMatch").addClass("pr-met");
                            mustMatchDone = true;
                        } else {
                            $(".pr-mustMatch").removeClass("pr-met");
                            mustMatchDone = false;
                        }
                    }

                    // checkCompleted();
                });
            });
        }
    });
})(jQuery);
